// images
import contact_banner from "../../assets/contact_banner.webp";
import renov1 from "../../assets/renov1.webp";
import renov2 from "../../assets/proj/renovation/renov2.jpeg";
import renov3 from "../../assets/proj/renovation/renov3.jpg";
import renov4 from "../../assets/proj/renovation/renov4.jpg";
import renov5 from "../../assets/proj/renovation/renove5.jpg";
import renov6 from "../../assets/proj/renovation/renov6.jpg";
import renov7 from "../../assets/proj/renovation/renov7.jpg";
import renovated from "../../assets/proj/renovation/renovated.jpg";

import glassdoor1 from "../../assets/proj/renovation/glassdoor1.jpg";
import glassdoor2 from "../../assets/proj/renovation/glassdoor2.jpg";

import rollup1 from "../../assets/proj/renovation/rollup.jpg";
import rollup2 from "../../assets/proj/renovation/rollup1.jpg";

export const services_list = [
  {
    images: [contact_banner, renov1],
    maintext: "Construction",
    subtext:
      "From groundbreaking to project completion, we bring expertise and precision to every detail, ensuring the seamless creation of spaces that stand the test of time.",
    route: "",
    status: "on-going",
    location: "Head Office",
  },
  {
    images: [renovated, renov2, renov1, renov4, renov5, renov6, renov7],
    maintext: "Renovation",
    subtext:
      "Transform your space with our comprehensive renovation services. From concept to completion, we handle every aspect, ensuring a seamless process that breathes new life into your home or office.",
    route: "",
    status: "on-going",
    location: "Main Office",
  },

  {
    images: [renov3, renov1],
    maintext: "FLOOR PAINTING",
    subtext:
      "Providing a durable and stylish solution to enhance your interior design. Our skilled team ensures meticulous application, creating a seamless and visually striking foundation for any room.",
    route: "",
    status: "on-going",
    location: "Sta.Rosa, Laguna",
  },
  {
    images: [contact_banner, renov1],
    maintext: "INSTALLATION OF WALL & TABLE PARTITON",
    subtext:
      "Our team ensures precise placement, offering a seamless solution for enhanced functionality and aesthetic appeal in your interior design. Trust us to transform your environment with efficiency and expertise.",
    route: "",
    status: "completed",
    location: "Sta.Rosa, Laguna",
  },
  {
    images: [rollup1, rollup2],
    maintext: "Roll-up door installation",
    subtext:
      "Our skilled technicians ensure efficient and precise fitting, providing a durable solution that combines functionality with a modern aesthetic. Elevate your space with the convenience and reliability of our professional roll-up door installations.",
    route: "",
    status: "completed",
    location: "pallocan west, batangas city",
  },
  {
    images: [glassdoor1, glassdoor2],
    maintext: "INSTALLATION OF GLASS WALL PARTITION (HR OFFICE)",
    subtext:
      "Experience the elegance of seamless living with our expert glass door installation services. Our skilled team ensures precision in fitting and alignment, bringing a touch of sophistication to your space while maximizing natural light and visual appeal.",
    route: "",
    status: "completed",
    location: "pallocan west, batangas city",
  },
  {
    images: [contact_banner, renov1],
    maintext: "INSTALLATION OF ED GLASS DOOR (HR OFFICE)",
    subtext:
      "Experience the elegance of seamless living with our expert glass door installation services. Our skilled team ensures precision in fitting and alignment, bringing a touch of sophistication to your space while maximizing natural light and visual appeal.",
    route: "",
    status: "completed",
    location: "pallocan west, batangas city",
  },
  {
    images: [contact_banner, renov1],
    maintext: "INSTALLATION OF WALL & TABLE PARTITON",
    subtext:
      "Experience the elegance of seamless living with our expert glass door installation services. Our skilled team ensures precision in fitting and alignment, bringing a touch of sophistication to your space while maximizing natural light and visual appeal.",
    route: "",
    status: "completed",
    location: "Lipa Batangas",
  },
];
